import app from 'flarum/app';
import Button from 'flarum/components/Button';
import Modal from 'flarum/components/Modal';
import FormGroup from '../components/FormGroup';
import RichTextField from '../components/RichTextField';

/* global m */

const translationPrefix = 'kilowhat-formulaire.forum.auto-discussion-options-modal.';

export default class AutomaticDiscussionOptionsModal extends Modal {
    init() {
        this.options = this.props.options;
    }

    className() {
        return 'FormulaireModal FormulaireTheme';
    }

    title() {
        return app.translator.trans(translationPrefix + 'title');
    }

    content() {
        return m('.Modal-body', [
            m('.Form-group', m('p', app.translator.trans(translationPrefix + 'introduction'))),
            FormGroup.component({
                label: m('label', app.translator.trans(translationPrefix + 'field.title')),
            }, m('input.FormControl', {
                type: 'text',
                value: this.options.title || '',
                oninput: event => {
                    this.options.title = event.target.value;
                },
            })),
            FormGroup.component({
                label: m('label', app.translator.trans(translationPrefix + 'field.tags')),
                description: app.translator.trans(translationPrefix + 'field.tags-help'),
            }, m('input.FormControl', {
                type: 'text',
                value: this.options.tags || '',
                oninput: event => {
                    this.options.tags = event.target.value;
                },
            })),
            FormGroup.component({
                label: m('label', app.translator.trans(translationPrefix + 'field.content')),
            }, RichTextField.component({
                value: this.options.content || '',
                onchange: event => {
                    this.options.content = event.target.value;
                },
            })),
            m('.Form-group', Button.component({
                type: 'submit',
                className: 'Button Button--primary',
            }, app.translator.trans(translationPrefix + 'submit'))),
        ]);
    }

    onsubmit(event) {
        event.preventDefault();

        this.props.onchange(this.options);
    }
}
